import React from 'react';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { useHistory } from 'react-router-dom';
import { SettingsRoutes } from '../../../../routes/settings-routes';

export const useCreateCompanyWarningModal = () => {
  const history = useHistory();
  const { openNewInfoModal, openCreateCompanyModal, closeModal } =
    useModalActions();

  const navigateToUsersPage = () => {
    history.push(SettingsRoutes.users.path);
    closeModal();
  };

  const showCreateCompanyWarningModal = () =>
    openNewInfoModal({
      title: 'Attention!',
      description: (
        <div className="company-panel_create-company-modal-description">
          Your new company will be entirely separate from your current
          companies.
          <br />
          <br />
          <span style={{ fontWeight: 500 }}>
            No users, pages, or subscriptions will be moved.
          </span>
          <br />
          <br />
          Any pages connected to your new company will be billed separately from
          your current companies.
          <br />
          <br />
          If you simply wish to {''}
          <span
            className="company-panel_create-company-modal-link"
            onClick={navigateToUsersPage}
          >
            restrict users' access
          </span>
          {''} to only one page or to several pages, consider inviting them to
          your current company as an Editor instead.
        </div>
      ),
      button: 'Ok, I understand',
      onClick: openCreateCompanyModal,
      css: {
        container: 'company-panel_create-company-modal-container',
      },
    });

  return { showCreateCompanyWarningModal };
};
